import createMuiTheme from './createMuiTheme';
var defaultTheme = createMuiTheme();
export default defaultTheme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/styles/defaultTheme.js
// module id = 183
// module chunks = 0